import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { withStyles } from '@material-ui/styles';
import { CSVLink } from 'react-csv';
import flowRight from 'lodash.flowright';
import clsx from 'clsx';
import { connect } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';

import styles from '../styles/subscriptionCsvDownload';
import createSubscriptionColumnsLabels from '../actions/createColumnsLabels';
import Optional from '../../../utils/optional';
import mapDataForExport from '../actions/mapDataForExport';
import { translate } from '../../../i18n/I18nProvider';

const SubscriptionCsvDownload = ({
  classes,
  subscriptions,
  lang,
  selectedAccount,
  filters
}) => {
  const [csvData, setCsvData] = useState([]);
  const [headers, setHeaders] = useState([]);

  useEffect(() => {
    const columns = createSubscriptionColumnsLabels();
    setHeaders(columns);
  }, []);

  const fileName = useMemo(
    () =>
      `${translate('MENU.SUBSCRIPTIONS')} - ${selectedAccount.shortLabel}.csv`,
    [selectedAccount]
  );

  const csvLink = useRef();

  const onClick = useCallback(async () => {
    const mappedData = await mapDataForExport({
      subscriptions,
      lang,
      filters
    });
    setCsvData(mappedData);
    return csvLink.current.link.click();
  }, [subscriptions, lang, filters]);

  return (
    <div>
      <Tooltip title={`${translate('TABLE.EXPORT_AS')} csv`}>
        <div style={{ display: 'inline-block' }}>
          <i
            onClick={onClick}
            className={clsx('fas fa-download', classes.root)}
          />
          <CSVLink
            data={csvData}
            headers={headers}
            filename={fileName}
            className={classes.link}
            ref={csvLink}
            separator={';'}
            target="_blank"
          />
        </div>
      </Tooltip>
    </div>
  );
};

const mapStatesToProps = ({ subscriptionsImproved, auth }) => {
  return {
    subscriptions: subscriptionsImproved.subscriptions,
    selectedAccount: subscriptionsImproved.selectedAccount,
    lang: Optional(auth.lang).or('default'),
    filters: subscriptionsImproved.filters
  };
};

export default flowRight(
  connect(mapStatesToProps),
  withStyles(styles)
)(SubscriptionCsvDownload);
